import { DataBean } from "../DataBean";

export class BodyMeasurements extends DataBean {


    public async getBodyMeasurementsCatalogPorPropiedades(properties: any, maxRows: any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getBodyMeasurementsCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async getBodyMeasurementsCatalogPorPropiedadesRender(properties: any, maxRows: any): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getBodyMeasurementsCatalogPorPropiedadesRender_java.util.Map_Number", [properties, maxRows]);
    }

    public async updateBodyMeasurements(bean: any): Promise<any> {
        return this.getCustomService("TalentERP", "com.orange.people.talent.bean.BodyMeasurements_updateBodyMeasurements_com.orange.people.talent.bean.BodyMeasurements", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.orange.people.talent.bean.BodyMeasurements"
            }
        ]);
    }
}